import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Tooltip,
  title: 'Tooltip',
  category: ComponentCategory.General,
  droppable: true,
};
